import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../api/client";
import { useKitchenStore } from "../stores/kitchen.store";

export default function Login() {
  const navigate = useNavigate();
  const setJwtToken = useKitchenStore((s) => s.setJwtToken);
  const setClientId = useKitchenStore((s) => s.setClientId);
  const setUserName = useKitchenStore((s) => s.setUserName);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // 1. Login
      const { token, user } = await authApi.login(email, password);
      setJwtToken(token);
      setUserName(user.name);

      // 2. Fetch user's clients
      const clients = await authApi.getMyClients(token);

      if (clients.length === 0) {
        setError("Nessun ristorante associato a questo account");
        setJwtToken(null);
        setLoading(false);
        return;
      }

      // If only one client, use it automatically
      if (clients.length === 1) {
        setClientId(clients[0].id);
        navigate("/");
      } else {
        // Store clients for selection
        setClientId(null);
        navigate("/select-client", { state: { clients } });
      }
    } catch (err: any) {
      setError(err.message || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-kds-bg">
      <div className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-kds-text">Voxli Kitchen</h1>
          <p className="text-kds-muted mt-2">Accedi al sistema comande</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {error && (
            <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 text-red-400 text-sm">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="email" className="block text-sm text-kds-muted mb-1.5">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nome@ristorante.it"
              required
              autoFocus
              className="w-full bg-kds-surface border border-kds-muted/30 rounded-lg px-4 py-3 text-kds-text placeholder-kds-muted/50 focus:outline-none focus:border-blue-500 transition-colors"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm text-kds-muted mb-1.5">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="w-full bg-kds-surface border border-kds-muted/30 rounded-lg px-4 py-3 text-kds-text placeholder-kds-muted/50 focus:outline-none focus:border-blue-500 transition-colors"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-600/50 text-white font-medium rounded-lg px-4 py-3 transition-colors"
          >
            {loading ? "Accesso in corso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
